import { Type } from "../Models/GeocodeResponse.js";
import { GtfsService } from "./Gtfs/GtfsService.js";

export class TypeSortingService {
  /**
   * Sort the given array of features, in place, according to the location type or feature type.
   *
   * @param {Feature<Point, any>[]} features FeatureCollection
   * @returns {Feature<Point, any>[]} The given featureCollection with its features sorted. Note that the
   * features are sorted in place and no copy is made.
   */
  static sort(features) {
    features.sort((feature, otherFeature) => {
      // Convert the values of the boolean to int (false => 0, true => 1), defaulting to 0
      const featureGtfsSortValue = (feature.properties.type === Type.GTFS) | 0;
      const otherFeatureGtfsSortValue = (otherFeature.properties.type === Type.GTFS) | 0;

      // If either feature is not type GTFS, then compare using the type
      // Else, compare using if the features are GTFS stations
      if (!featureGtfsSortValue || !otherFeatureGtfsSortValue) {
        // return <0 to sort a,b; return >0 to sort b,a; return 0 to keep original order
        return otherFeatureGtfsSortValue - featureGtfsSortValue;
      } else {
        // Convert the values of the boolean to int (false => 0, true => 1), defaulting to 0
        const featureStationSortValue = GtfsService.isFeatureStation(feature) | 0;
        const otherFeatureStationSortValue = GtfsService.isFeatureStation(otherFeature) | 0;
        // return <0 to sort a,b; return >0 to sort b,a; return 0 to keep original order
        return otherFeatureStationSortValue - featureStationSortValue;
      }
    });
    return features;
  }
}
